<template>
	<v-card flat :class="{ removing: removingItem }">
		<div
			class="basket-product-height"
			:class="{ combinator: receiptLine.type === 'CombinatorLine' }"
			data-gtm-order-item="true"
		>
			<div class="width-product-description">
				<div class="product-title-price-wrapper">
					<div class="product-title" data-gtm-order-item-name="true" :data-cy="receiptLine.name">
						<template v-if="receiptLine.type === 'CombinatorLine'">
							<span v-if="receiptLine.name">
								{{ receiptLine.name }}
							</span>
							<span v-else>
								{{ $t("admin.priceRules.priceRulesForm.types.familyDiscount") }}
							</span>
						</template>
						<template v-else>
							{{ receiptLine.name }}
						</template>
						<template v-if="highlightReceiptLineDescription">
							<div class="highlight-name-color">{{highlightReceiptLineDescription.text}}</div>
						</template>
					</div>
					<div class="product-price-container" v-if="isGeneration5" data-gtm-order-item-price="true">
						<p :class="{'product-price-before': shouldShowBothPrices, 'product-price': !shouldShowBothPrices}">
							{{
								formatPriceZero(shouldShowBothPrices ? receiptLine.totalPriceBefore : receiptLine.totalPriceAccum)
							}}
						</p>
						<p class="highlight-name-color product-price" v-if="shouldShowBothPrices">
							{{
								formatPriceZero(receiptLine.totalPriceAccum)
							}}
						</p>
					</div>
					<div class="product-price-container" v-else data-gtm-order-item-price="true">
						<p class="product-price">
							{{ receiptLine.totalPrice | formatPrice }}
						</p>
					</div>
				</div>
				<v-divider></v-divider>
				<div class="product-description-wrapper">
					<div
						class="product-description"
					>
						<div class="size-price" v-if="!isGeneration5">
							<div class="menu-size" v-if="menuSize && orderLine.totalPriceAccum">
								{{ menuSize }} á {{ formatPriceZero(orderLine.totalPriceAccum) }}
							</div>
							<div
								class="unit-price"
								v-if="productQuantity > 1 && receiptLine.price"
								data-gtm-order-item-quantity="true"
							>
								á
								{{
									formatPriceZeroWithTotalPriceAndQuantity(
										receiptLine.price,
										receiptLine.totalPrice,
										receiptLine.quantity
									)
								}}
							</div>
						</div>
						<div
							v-for="(desc, index) in receiptLine.description"
							:key="index"
							:class="{
								'receipt-header': desc.indent <= 1,
								'receipt-not-header': desc.indent > 1
							}"
						>
							<template v-if="!isForbidden(desc.text)">
								{{ desc.name }}
								<span>{{ desc.text }}</span>
							</template>
						</div>
					</div>

				</div>
				<v-container class="order-item-wrapper">
					<v-layout>
						<AddDips
							:product="product"
							:orderLine="orderLine"
							@addDipsButtonClicked="addDipsButtonClicked"
						/>
					</v-layout>
					<v-layout class="order-item-actions">
						<v-flex class="order-item-remove-edit product-edit">
							<v-btn
								flat
								class="remove-ease-button"
								@click="protectRemoveItem(() => removeFromCart(), 'shopComponents.gt2.shoppingCart_steps.shoppingCartStepCheckoutInit.removeItem', true, false)"
								:ripple="false"
								data-gtm-remove-from-cart="true"
								>{{$t("shopComponents.gt3.shoppingCart.orderItem.remove")}}
							</v-btn>
							<v-btn
								v-if="hasConfigurationOrGroup && receiptLine.type !== 'CombinatorLine'"
								flat
								class="remove-ease-button"
								@click="editProductSelection"
								:ripple="false"
								:disabled="isProductConfiguring"
								data-gtm-product-edit="true"
								>{{$t("shopComponents.gt3.shoppingCart.orderItem.edit")}}
							</v-btn>

						</v-flex>
						<v-flex
							class="basket-layout amount-btn-edit order-item-change-quantity"
							v-if="productSelection && !isProductConfiguring && (!product.options.deals || !product.options.deals.isDealsEnabled)"
							data-gtm-order-item-quantity="true"
						>
							<v-btn
								v-if="!cartQuantityDialogShown"
								class="add-btn-selected-color"
								:ripple="false"
								@click="openQuantityPopUp"
							>
								{{ productSelection.quantityWithoutCombinator || productSelection.quantity }}
							</v-btn>
							<div v-else class="add-remove-btn">
								<v-btn
									flat
									:ripple="false"
									@click.stop="changeQuantity(productSelection.quantity - 1)"
									data-gtm-remove-from-cart="true"
								>
									<div class="remove-image"></div>
								</v-btn>
								<v-chip label>{{ productSelection.quantityWithoutCombinator || productSelection.quantity }}</v-chip>
								<v-btn
									flat
									:ripple="false"
									@click.stop="changeQuantity(productSelection.quantity + 1, true)"
									data-gtm-add-to-cart="true"
									:disabled="product.options.deals && product.options.deals.isDealsEnabled"
								>
									<div class="add-image"></div>
								</v-btn>
							</div>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-btn v-if="featureToggles.enableBasketProductSelectionUpgradeToMenu && singleMainProductIdsToMenuIdsMap && singleMainProductIdsToMenuIdsMap[product.id]" class="next green-btn btn-secondary upgrade-to-menu-basket-button" primary flats @click="upgradeToMenu">
							<span>
								{{ $t("shopComponents.gt3.shoppingCart.orderItem.upgradeToMenu", {priceDiff: priceDifference()}) }}
							</span>
						</v-btn>
					</v-layout>
				</v-container>
			</div>
		</div>
		<confirmation-dialog
			:dialogOpened="dialogOpened"
			:onClose="closeConfirmDialog"
			:onConfirm="currentConfirmAction"
			:text="$t(dialogText)"
			:removeItemFromBasket="removeItemFromBasket"
			:removeItemFromQuantity="removeItemFromQuantity"
			class="confirmation-dialog2"
		/>
		<dips-dialog
			v-if="showDipsDialog"
			:productId="product.id"
			:category="findCategory(product.id)"
			:categoryId="findCategory(product.id).extId"
			:productSelectionId="productSelection.productSelectionId"
			:onClose="closeDipsDialog"
			:showDialog="showDipsDialog"
			:key="productSelection.productSelectionId"
		/>
	</v-card>
</template>

<script>
import * as Utils from "../../../../libraries/utils";
import OrderItemCommonMixin from "../../../../mixins/OrderItemCommon.mixin";
import {CONFIGURATION_STATE_TYPE, resetConfigurationStep} from "../../../../libraries/utils";
import ConfirmationDialog from "../../../UtilityComponents/ConfirmationDialog.vue";
import UpgradeToMenuFromBasket from "../../../../helper/UpgradeToMenuFromBasketHelper";
import { mapGetters } from "vuex";
import {generateDifferentiatedGroups} from "../../../../helper/ProductSelectionHelper";
import {hasBaseProductWithGroupsAndConfigurations} from "../../../../helper/ProductHelper";
import appConfig, {channelEnum} from "../../../../appconfig";
import AddDips from "../../../UtilityComponents/Cart/AddDips.vue";
import DipsDialog from "../../defaultGlobalTemplate/Dialogs/DipsDialog.vue";

export default {
	name: "OrderItem-gt3",
	components: {AddDips, DipsDialog, ConfirmationDialog},
	props: [
		"productSelection",
		"receiptLine",
		"orderLine",
		"product",
		"isProductConfiguring",
		"globalSelectedShop",
		"productCatalog",
		"tenantSettings"
	],
	mixins: [OrderItemCommonMixin],
	data() {
		return {
			timeoutHandle: null,
			removingItem: false,
			showDipsDialog: false
		};
	},
	computed: {
		...mapGetters(["featureToggles", "singleMainProductIdsToMenuIdsMap"]),
		isKioskChannel() {
			return appConfig.channelAlias() === channelEnum.kiosk;
		},
		highlightReceiptLineDescription(){
			return this.receiptLine.highlightDescription.find(Boolean);
		},
		shouldShowBothPrices() {
			return this.receiptLine.type !== "CombinatorLine" && this.highlightReceiptLineDescription;
		},
		loadSingleStepMenu() {
			// Note: this feature is only required on kiosks for now, but we may setup ab test - without checking that explicitly here
			return this.$store.getters.featureToggles.enableOneStepMenu
				&& this.$store.getters.featureToggles.moveTopMenuToTheLeftSide
				&& this.isKioskChannel
				&& this.product
				&& hasBaseProductWithGroupsAndConfigurations(this.product);
		}
	},
	methods: {
		closeDipsDialog() {
			this.showDipsDialog = false;
		},
		addDipsButtonClicked() {
			this.showDipsDialog = true;
		},
		priceDifference() {
			return UpgradeToMenuFromBasket.priceDiff(this);
		},
		upgradeToMenu() {
			const self = this;
			UpgradeToMenuFromBasket.goToCatalog(self);
		},
		configurationSteps(product) {
			return Utils.generateProductConfigSteps(product);
		},
		findCategory(productId) {
			const self = this;
			const categories = Utils.getCategoriesByShopId(
				self.globalSelectedShop.id,
				self.productCatalog
			);
			return categories.find((cat) => {
				return (
					cat.elements.find((element) => {
						if (element.objType === "GridBlockElement") {
							return (
								element.items.find((product) => product.id === productId) !== undefined
							);
						} else if (element.props && element.props.products) {
							return (
								element.props.products.find((product) => product === productId) !== undefined
							);
						} else {
							return false;
						}
					}) !== undefined
				);
			});
		},
		editProductSelection() {
			const self = this;
			resetConfigurationStep(self);
			const findConfigurationType = function (product) {
				const steps = self.configurationSteps(product);
				if (steps.length > 0) {
					return steps[0] === CONFIGURATION_STATE_TYPE.DRINKS
						? CONFIGURATION_STATE_TYPE.EXTRAS.toLowerCase()
						: steps[0].toLowerCase();
				} else {
					return null;
				}
			};
			const category = self.findCategory(self.productSelection.productId);
			const product = self.product;
			const configurationType = findConfigurationType(product, category);
			const productSelectionId = self.productSelection.productSelectionId;
			self.$router.push(
				`/category/${category.extId}`
			);
			if(this.loadSingleStepMenu) {
				generateDifferentiatedGroups(product);
				setTimeout(() => {
					self.$router.push(
						`/category/${category.extId}/${product.id}/configuration/${productSelectionId}`
					);
				}, 100);
			} else {
				setTimeout(() => {
					self.$router.push(
						`/category/${category.extId}/${product.id}/configuration/${configurationType}/${productSelectionId}`
					);
				}, 100);
			}
		}
	}
};
</script>

<style scoped lang="scss">
.basket-product-height {
	min-height: 140px;
	.width-product-description {
		.product-description-wrapper {
			.product-description {
				margin-bottom: 0;
			}
		}
	}
	.order-item-wrapper {
		height: auto;
		padding: 0;
		.order-item-actions {
			height: 60px;
			.order-item-remove-edit {
				align-self: flex-end;
			}
			.order-item-change-quantity.amount-btn-edit {
				justify-content: flex-end;
				align-items: flex-end;
				.add-remove-btn {
					right: 0;
					width: max-content;
				}
			}
		}
	}
}

.basket-layout {
	display: inline-grid;

	.product-title {
		font-size: 22px;
		padding-bottom: 10px;
		line-height: 1;
	}

	.product-description {
		line-height: 1.4;
		padding-bottom: 20px;
		font-size: 17px;
	}
}

.amount-btn-edit {
	// position: absolute;
	right: 10px;

	.add-btn-selected-color {
		background-color: #ffc627 !important;
		color: #231f20 !important;
		font-size: 30px;
		border: 1px solid #ffc627;
		height: 44px;
		width: 44px;
		min-width: 44px;
		border-radius: 4px;
		will-change: box-shadow;
		box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
			0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
	}

	.edit-button-cr {
		background-color: white !important;
		height: 44px;
		width: 44px;
		min-width: 44px;
		border-radius: 4px;
	}

	.total-price,
	.discounted-total-price {
		font-size: 15px;
	}

	.discounted-total-price {
		.menu-price,
		.old-menu-price {
			display: inline;
		}
	}

	.edit-button-cr .v-icon {
		font-size: 32px;
	}

	.add-remove-btn {
		position: relative;
		text-align: center;
		background-color: #fff;
		-webkit-border-radius: 6px;
		-moz-border-radius: 6px;
		border-radius: 6px;
		box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
			0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
		padding: 4px;

		.v-btn {
			height: 44px;
			width: 44px;
			min-width: 44px;
			-webkit-border-radius: 4px;
			-moz-border-radius: 4px;
			border-radius: 4px;
			margin: 0;

			.v-btn__content {
				padding: 0 12px;
			}

			.v-icon {
				font-weight: bold;
			}
		}

		.v-chip {
			background-color: #ffffff;
			font-weight: bold;
			font-size: 30px;
			min-width: 60px;
			text-align: center;
			color: #231f20;
			margin: 4px 16px;

			/deep/ .v-chip__content {
				margin: 0 auto;
			}
		}

		.v-btn:last-child {
			background-color: #ffc627 !important;
			color: #231f20;
		}

		.v-btn:first-child {
			background-color: #d8d8d8 !important;
			color: #231f20;
		}
	}
}

@media (max-width: 420px) {
	.product-description {
		font-size: 15px !important;
	}
}

.theme--light .v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
	background-color: #ffc627 !important;
	color: #231f20 !important;
	font-size: 30px;
	border: 1px solid #ffc627;
	height: 44px;
	width: 44px;
	min-width: 44px;
	border-radius: 4px;
	will-change: box-shadow;
	box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
		0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
}

.bullet-basket-product {
	font-size: 8px;
	color: #23282a;
	padding-bottom: 4px;
	padding-right: 2px;
}

.lowercase-menu {
	text-transform: lowercase;
}

.remove-ease-button {
	margin-left: 0 !important;
	color: #63666a;
	text-decoration: underline;
	width: 35px !important;
	min-width: 35px !important;
	height: 25px !important;
	text-transform: capitalize;
	font-size: 16px;
}
.remove-ease-button.v-btn[disabled] {
	background: white !important;
	margin-left: 0 !important;
	color: #9fa9ac !important;
	text-decoration: underline !important;
	width: 35px !important;
	min-width: 35px !important;
	height: 25px !important;
	text-transform: capitalize !important;
	font-size: 16px !important;
}
.product-description {
	flex-direction: column;
	display: flex;
	font-family: Dispatch;
	font-size: 13px !important;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.46;
	letter-spacing: normal;
	color: #222222;
	margin-top: 4px;
	margin-bottom: 29px;
	.size-price {
		font-family: Dispatch;
		font-size: 14px;
		font-weight: bold;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.36;
		letter-spacing: normal;
		color: #000000;
		padding-top: 16px;
	}
}
.highlight-name-color{
	text-transform: none;
	color: #218C74;
}

.product-price-container{
	color: grey;
}
.product-price-before {
	color: grey;
	text-decoration: line-through;
}
.product-price-container p {
	margin: 0;
	text-align: center;
}
.removing {
	transition: opacity 1s, transform 1s;
	opacity: 0;
	transform: scaleY(0);
}
.v-btn.green-btn.upgrade-to-menu-basket-button {
	text-transform: none;
	height: 34px !important;
	margin-top: 8px;
	span {
		font-size: 14px;
		font-weight: 700;
	}
}
</style>
